/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    SAVE: 'Zapisz',
    SUBMIT: 'Prześlij'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Błąd podczas anulowania kontrahenta',
    COUNTERPART_DETAILS_SUBMIT: 'Błąd przesyłania odpowiednika',
    DELETE_ATTACHMENT: 'Błąd usuwania załącznika',
    DELETE_LINK: 'Błąd usuwania łącza',
    ERROR: 'Błąd',
    FILE_SIZE: 'Wybrany plik przekracza limit 8 MB',
    MAX_FILES_UPLOAD: 'Nie można przesłać więcej niż 8 MB jednocześnie',
    PUBLISHED_AT_ERROR: 'Data publikacji jest obowiązkowa'
  },
  HEADER: {
    APPROVED_BY: 'Zatwierdzony przez',
    ATTACHMENT: 'Załączniki',
    COMMENT: 'Komentarz',
    CONFIRMATION_DATE: 'Potwierdzenie',
    CURRENT_PARTNER_TASKS: 'P. Corr',
    DESCRIPTION: 'Opis',
    END_DATE: 'Data zakończenia',
    LINK: 'Linki',
    MANAGER_COMMENT: 'Komentarz menedżera',
    MONTH: 'Miesiąc',
    PERIODICITY: 'Częstotliwość',
    PREVIOUS_PARTNER_TASKS: 'P. Ant',
    REQUIRED: 'Wymagane',
    START_DATE: 'Data rozpoczęcia',
    STATE: 'Stan',
    SUBMISSION_DATE: 'Zgłoszenie'
  },
  LABEL: {
    ATTACHMENTS: 'Załączniki',
    ATTACHMENTS_UPLOADED: 'Przesłane załączniki',
    CANCEL_COUNTERPART: 'Anuluj',
    CLOSE: 'Zamknij',
    COMMENT: 'Komentarz',
    CONFIRM: 'Potwierdzenie',
    DESCRIPTION: 'Opis',
    FILTER_MONTH_APR: 'Kwiecień',
    FILTER_MONTH_AUG: 'Sierpień',
    FILTER_MONTH_DEC: 'Grudzień',
    FILTER_MONTH_FEB: 'Luty',
    FILTER_MONTH_JAN: 'Styczeń',
    FILTER_MONTH_JUL: 'Lipiec',
    FILTER_MONTH_JUN: 'Czerwiec',
    FILTER_MONTH_MAR: 'Marzec',
    FILTER_MONTH_MAY: 'Maj',
    FILTER_MONTH_NOV: 'Listopad',
    FILTER_MONTH_OCT: 'Październik',
    FILTER_MONTH_SEP: 'Wrzesień',
    LINK: 'Link',
    LINKS: 'Linki',
    LINKS_UPLOADED: 'Przesłane łącza',
    MONTH: 'Miesiąc',
    PUBLISHED_AT: 'Data publikacji',
    STATE: 'Stan',
    SUBMIT_COUNTERPART: 'Prześlij',
    YEAR: 'Rok'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Czy na pewno chcesz anulować zgłoszenie odpowiednika?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Czy na pewno chcesz przesłać odpowiednik?',
    NO_ROWS_ATTACHMENT: 'Brak załączników'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Załącznik usunięty',
    CANCEL_COUNTERPART: 'Odpowiednik anulowany',
    COUNTERPART_DETAILS_SUBMIT: 'Przekazane dane kontrahenta',
    LINK_DELETED: 'Link usunięty',
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    ADD_LINK: 'Nowy link',
    APPROVED_BY: 'Kontrahent zatwierdzony przez',
    ATTACHMENT: 'Załączniki',
    COMMENT: 'Komentarz',
    CONFIRMATION_DATE: 'Data potwierdzenia kontrahenta',
    CURRENT_PARTNER_TASKS:
      'Liczba rekordów za bieżący okres do przedłożenia przez partnera',
    DESCRIPTION: 'Opis',
    END_DATE: 'Data zakończenia',
    LINK: 'Linki',
    MANAGER_COMMENT: 'Komentarz menedżera',
    MONTH: 'Miesiąc',
    PERIODICITY: 'Częstotliwość',
    PREVIOUS_PARTNER_TASKS:
      'Liczba rekordów z poprzedniego okresu, które partner musi jeszcze dostarczyć',
    REMOVE_LINK: 'Usuń link',
    REQUIRED: 'Wymagane',
    START_DATE: 'Data rozpoczęcia',
    STATE: 'Stan',
    SUBMISSION_DATE: 'Data przedłożenia strony przeciwnej'
  }
};
